import _ from 'lodash';

export const formatBuyType = buyType => (buyType ? _.snakeCase(buyType) : buyType);

export default formatBuyType;
